import cloudIcon from "@assets/images/cloud.svg";
import { Button, Dialog, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

interface OrderProcessErrorProps {
  errorMessage?: string;
  open?: boolean;
  onClose(): void;
}

const useStyle = makeStyles(
  theme => ({
    root: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    mainPanel: {
      background: "transparent"
    },
    headTextLogo: {
      margin: "120px 0 104px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.5s ease"
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      padding: "5px 15px",
      borderRight: "solid 1px #E41B17"
    },
    logo: {
      marginLeft: 20
    },
    footer: {
      position: "absolute",
      bottom: "2.4rem",
      textAlign: "center",
      width: "100%"
    },
    paper: {
      width: "420px",
      padding: "43px 32px 32px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.6rem"
    },
    cloudIcon: {
      width: 56,
      height: 56,
      marginBottom: "2.7rem"
    },
    des: {
      marginBottom: "1.6rem",
      textAlign: "center"
    },
    errorcode: {
      color: theme.palette.grey[500],
      marginBottom: "1.6rem"
    },
    btnSubmit: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      borderRadius: "4px",
      width: "100%",
      padding: "12px",

      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    }
  }),
  { name: "OrderProcessingFailedView" }
);

const OrderBeingProcessError: React.FC<OrderProcessErrorProps> = props => {
  const { open, onClose, errorMessage } = props;
  const classes = useStyle();

  return (
    <Dialog open={open} onClose={onClose}>
      <Paper className={classes.paper}>
        <img src={cloudIcon} alt="" className={classes.cloudIcon} />
        <MyTypography variant="h6" className={classes.caption}>
          ไม่สามารถทำรายการใด้
        </MyTypography>
        <MyTypography variant="body2" className={classes.des}>
          เนื่องจากใบสั่งซื้อถูกเปิดใช้งานอยู่
        </MyTypography>
        <MyTypography variant="body3" className={classes.errorcode}>
          {errorMessage}
        </MyTypography>
        <Button
          id="closeButton"
          data-testid="closeButton"
          onClick={onClose}
          className={classes.btnSubmit}
        >
          <MyTypography variant="body1">Back</MyTypography>
        </Button>
      </Paper>
    </Dialog>
  );
};

export default OrderBeingProcessError;
